module.exports = __webpack_public_path__ + "static/media/ourbusiness_investment.fa220398.png";